export default "__VITE_ASSET__432f6cd1__$_?nuxt_component=async__"